import React from "react";
import _ from "lodash";
import Select from "Components/select/Select";
import Button from "Components/button/Button";
import WarningBanner from "Components/warningBanner/WarningBanner";
import DomainLimitsInputs from "Components/domainLimitsInputs/DomainLimitsInputs";
import { t } from "i18next";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";
import QuotaSelector from "Components/quotaSelector/QuotaSelector";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import { Icon, warningFill } from "Icons/index";
import cx from "classnames";
import TranslatedString from "Components/TranslatedString";
import { quotas, humanQuotas } from "../../../config";

export default class ProfileForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = (e) => {
    e.preventDefault();
    this.props.setDataForm(this.state.formData);
    this.props.goToStep(4);
  };

  setMaxEmailQuota = (val) => {
    let maxQuota = val.max_email_quota;

    if (maxQuota < this.props.formData.default_quota) {
      this.props.setFormFieldValue({ default_quota: val.max_email_quota });
    }

    // auto-set value of limits on email accounts based on the new quota
    if (maxQuota < humanQuotas["100GB"]) {
      this.props.setFormFieldValue({ max_email_accounts_100gb: 0 });
    }

    if (maxQuota < humanQuotas["50GB"]) {
      this.props.setFormFieldValue({ max_email_accounts_50gb: 0 });
    }

    if (maxQuota < humanQuotas["16GB"]) {
      this.props.setFormFieldValue({ max_email_accounts_25gb: 0 });
    }

    this.props.setFormFieldValue(val);
  };

  render() {
    const { formData, setFormFieldValue, formErrors, isloggedUserInTrial, isLoggedUserAdmin, selectedCustomer } =
      this.props;

    const hasOrderedDomains = !!this.props.loggedUser.ordered_domains;

    let hiddenQuotas = [];
    let disabledDefaults = [];
    let disabledQuotas = [];
    let disabledLimits = [];
    let disabledFields = [];

    /* cannot have email accounts of 25GB if is in trial  */
    const isTrial = isloggedUserInTrial || (isLoggedUserAdmin && selectedCustomer.plan === "trial");
    if (isTrial) {
      disabledQuotas.push(humanQuotas["16GB"]);
      disabledQuotas.push(humanQuotas["25GB"]);
      disabledQuotas.push(humanQuotas["50GB"]);
      disabledQuotas.push(humanQuotas["100GB"]);
    }

    if (formData.plan === "basic") {
      hiddenQuotas.push(humanQuotas["50GB"]);
    }

    // 100gb can't be setted while adding a domain but only after creation
    if (formData.plan !== "enterprise") {
      hiddenQuotas.push(humanQuotas["100GB"]);
    }

    if (formData.max_email_quota < humanQuotas["100GB"]) {
      disabledFields.push("max_email_accounts_100gb");
    }

    if (formData.max_email_quota < humanQuotas["50GB"]) {
      disabledFields.push("max_email_accounts_50gb");
    }

    if (formData.max_email_quota < humanQuotas["16GB"]) {
      disabledFields.push("max_email_accounts_25gb");
    }

    // disable default quotas
    quotas.forEach((q) => {
      if (q.value > parseInt(formData.max_email_quota)) {
        disabledDefaults.push(q.value);
      }
    });

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("domains.add.title.step3")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("domains.add.desc.step3")}</div>
            <Button className="btnDocsFP" docsKey="domains_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit}>
            <div className="formsFP">
              <div className="inputFull2">
                <div className="settingTitle">{t("input.label.maxAccountsSize")}</div>
                <div className="sectionDesc">{t("settings.sections.domains.maxAccountSize")}</div>
              </div>

              <div className="inputFull2">
                <WarningBanner info color="blue" msg={<TranslatedString>infoMsg.maxQuota</TranslatedString>} />
              </div>

              <QuotaSelector
                className="inputFull2"
                onChange={this.setMaxEmailQuota}
                value={formData.max_email_quota}
                name="max_email_quota"
                errors={formErrors.max_email_quota}
                hidden={hiddenQuotas}
                disabledQuotas={disabledQuotas}
                disabled={hasOrderedDomains}
              />

              <div className="inputFull2">
                <div className="settingTitle">{t("input.label.accountsDefaultQuota")}</div>
                <div className="sectionDesc">{t("settings.sections.domains.maxAccountSize")}</div>
              </div>

              <QuotaSelector
                className="inputFull2"
                name="default_quota"
                value={formData.default_quota}
                errors={formErrors.default_quota}
                disabled={isloggedUserInTrial}
                onChange={setFormFieldValue}
                hidden={hiddenQuotas}
                disabledQuotas={disabledDefaults}
              />

              <div className="inputFull2">
                <div className="settingTitle">{t("settings.sections.domains.maxAccountsAvailable.title")}</div>
                <div className="sectionDesc">{t("settings.sections.domains.maxAccountsAvailable")}</div>
              </div>

              <DomainLimitsInputs
                className={cx("inputFull2", "inputAddMargin")}
                values={{
                  max_email_accounts: formData.max_email_accounts,
                  max_email_accounts_archive: formData.max_email_accounts_archive,
                  max_email_accounts_25gb: formData.max_email_accounts_25gb,
                  max_email_accounts_50gb: formData.max_email_accounts_50gb,
                  max_email_accounts_100gb: formData.max_email_accounts_100gb,
                }}
                errors={{
                  max_email_accounts: formErrors.max_email_accounts,
                  max_email_accounts_archive: formErrors.max_email_accounts_archive,
                  max_email_accounts_25gb: formErrors.max_email_accounts_25gb,
                  max_email_accounts_50gb: formErrors.max_email_accounts_50gb,
                  max_email_accounts_100gb: formErrors.max_email_accounts_100gb,
                }}
                plan={formData.plan}
                onChange={setFormFieldValue}
                disabled={this.props.isloggedUserInTrial || hasOrderedDomains}
                disabledFields={disabledFields}
              />
            </div>

            {(isloggedUserInTrial || formErrors.onForm) && (
              <div className="warningMsgFP">
                {isloggedUserInTrial && <WarningBanner msg={t("infoMsg.trialAdvancedSettings")} />}
                {formErrors.onForm && <WarningBanner color="red" msg={formErrors.onForm} />}
              </div>
            )}

            <div className="footerFP">
              <Button color="text" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit">
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
